import { render, staticRenderFns } from "./ExportHistoryModal.vue?vue&type=template&id=2a8ab1d0&scoped=true&lang=pug"
import script from "./ExportHistoryModal.vue?vue&type=script&lang=js"
export * from "./ExportHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./ExportHistoryModal.vue?vue&type=style&index=0&id=2a8ab1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ab1d0",
  null
  
)

export default component.exports